import { classNamesFunction, IProgressIndicatorStyles, IStyle } from '@fluentui/react';
import { SubStyle } from './commonStyles';
import { IThemedProp } from './themesUI';

// Request History
export interface IRequestHistoryStyles {
  root: IStyle;
  text: IStyle;
}

export const getRequestHistoryStyles = (props: IThemedProp): IRequestHistoryStyles => {
  const { theme } = props;
  return {
    root: {
      marginTop: '15px',
      color: theme.palette.neutralPrimary,
    },
    text: {
      marginTop: '10px',
      fontSize: '14px',
      color: theme.palette.neutralPrimary,
      '& > a': {
        color: theme.semanticColors.link,
      },
    },
  };
};

export const getRequestHistoryClassNames = classNamesFunction<{}, IRequestHistoryStyles>();

// Request List
export interface IRequestListStyles {
  noRequestMessage: IStyle,
  subComponentStyles: {
    progressIndicatorStyles: SubStyle<IProgressIndicatorStyles>
  }
}

export const getRequestListStyles = (props: IThemedProp): IRequestListStyles => {
  const { theme } = props;
  return {
    noRequestMessage: {
      marginTop: '10px',
      fontSize: '14px',
      color: theme.palette.neutralPrimary,
    },
    subComponentStyles: {
      progressIndicatorStyles: {
        root: {
          marginTop: '10px',
          fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
        },
        itemDescription: {
          marginTop: '10px',
          fontSize: '14px',
          color: theme.palette.neutralPrimary,
        },
        progressBar: {
          background: `linear-gradient(to right, rgb(237, 235, 233) 0%, ${theme.palette.blue} 50%, rgb(237, 235, 233) 100%)`,
        },
      },
    },
  };
};

export const getRequestListClassNames = classNamesFunction<{}, IRequestListStyles>();
